import Dashboard from '../components/Dashboard';
import FormLayoutDemo from '../components/FormLayoutDemo';
import InputDemo from '../components/InputDemo';
import FloatLabelDemo from '../components/FloatLabelDemo';
import ButtonDemo from '../components/ButtonDemo';
import TableDemo from '../components/TableDemo';
import ListDemo from '../components/ListDemo';
import TreeDemo from '../components/TreeDemo';
import PanelDemo from '../components/PanelDemo';
import OverlayDemo from '../components/OverlayDemo';
import MediaDemo from '../components/MediaDemo';
import MenuDemo from '../components/MenuDemo';
import MessagesDemo from '../components/MessagesDemo';
import FileDemo from '../components/FileDemo';
import MiscDemo from '../components/MiscDemo';
import BlocksDemo from '../components/BlocksDemo';
import CrudDemo from '../pages/CrudDemo';
import Help from '../pages/Help';
import EmptyPage from '../pages/EmptyPage';
import InvalidStateDemo from '../components/InvalidStateDemo';
import TimelineDemo from '../pages/TimelineDemo';
//NEW

import Asset from 'pages/Asset/Asset';
import SoftAsset from 'pages/SoftAsset/SoftAsset';
import Employee from 'pages/Employee/Employee';
import Vendor from 'pages/Vendor/Vendor';
import Registration from 'pages/Registration/Registration';
import Report from 'pages/Report/Report';
import ReportByCategoriesVsCompany from 'pages/Report/ReportByCategoriesVsCompany';
import ReportByCategoriesVsBrand from 'pages/Report/ReportByCategoriesVsBrand';
import ReportByDepartmentVsCategories from 'pages/Report/ReportByDepartmentVsCategories';
import Others from 'pages/Other/Others';
import {ChangePassword} from '../pages/UpdateProfile/ChangePassword';
import Logout from 'pages/Logout/Logout';


export const routes = [
    // { path: '/', element: <Dashboard />},
    { path: '/formlayout', element: <FormLayoutDemo />},
    { path: '/input', element: <InputDemo />},
    { path: '/floatlabel', element: <FloatLabelDemo />},
    { path: "/invalidstate", element: <InvalidStateDemo />},
    { path: '/button', element: <ButtonDemo />},
    { path: '/table', element: <TableDemo />},
    { path: '/list', element: <ListDemo />},
    { path: '/tree', element: <TreeDemo />},
    { path: '/panel', element: <PanelDemo />},
    { path: '/overlay', element: <OverlayDemo />},
    { path: '/media', element: <MediaDemo />},
    { path: '/menu/*', element: <MenuDemo />},
    { path: '/messages', element: <MessagesDemo />},
    { path: '/file', element: <FileDemo />},
    { path: '/misc', element: <MiscDemo />},
    { path: '/crud', element: <CrudDemo />},
    { path: '/blocks', element: <BlocksDemo />},
    { path: '/timeline', element: <TimelineDemo />},
    { path: '/help', element: <Help />},
    { path: '/empty', element: <EmptyPage />},
    { path: '/users', element: <Registration />},

    { path: '/asset', element: <Asset />},
    { path: '/soft/asset', element: <SoftAsset />},
    { path: '/vendor', element: <Vendor />},
    { path: '/employee', element: <Employee />},
    { path: '/report', element: <Report />},
    { path: '/report-by-category-vs-company', element: <ReportByCategoriesVsCompany />},
    { path: '/report-by-category-vs-brand', element: <ReportByCategoriesVsBrand />},
    { path: '/report-by-department-vs-category', element: <ReportByDepartmentVsCategories />},
    { path: '/others', element: <Others />},

    { path: '/change_password', element: <ChangePassword />},
    { path: '/logout', element: <Logout />},


];

export const routesStaff = [
    { path: '/asset', element: <Asset />},
    { path: '/soft/asset', element: <SoftAsset />},
    { path: '/vendor', element: <Vendor />},
    { path: '/employee', element: <Employee />},
    { path: '/others', element: <Others />},
    { path: '/report', element: <Report />},
    { path: '/report-by-category-vs-company', element: <ReportByCategoriesVsCompany />},
    { path: '/report-by-category-vs-brand', element: <ReportByCategoriesVsBrand />},
    { path: '/report-by-department-vs-category', element: <ReportByDepartmentVsCategories />},
    { path: '/change_password', element: <ChangePassword />},
    { path: '/logout', element: <Logout />},

];